<template>
    <transition
        :name="transitionName"
        :enter-active-class="transitionIn"
        :leave-active-class="transitionOut"
    >
        <div v-if="show"
             :class="cssClasses"
             role="alert"
             aria-live="polite"
             aria-atomic="true"
        >
            {{ message }}
        </div>
    </transition>
</template>

<script>
export default {
  data () {
    return {
      closed: false,
      timeout: null,
      duration: 3000
    }
  },
  props: {
    message: {
      default: null,
      type: String,
      required: true
    },
    variant: {
      type: String,
      required: true
    },
    autoHide: {
      type: Boolean,
      default: true
    },
    transitionName: {
      type: String,
      default: 'custom-classes-transition'
    },
    transitionIn: {
      type: String,
      default: 'animated fadeInDown'
    },
    transitionOut: {
      type: String,
      default: 'animated fadeOutUp'
    },
    customClass: {
      default: '',
      type: String,
      required: false
    }
  },
  mounted () {
    if (this.autoHide) {
      this.autoClose()
    }
  },
  computed: {
    variantClass () {
      return `alert-${this.variant}`
    },
    cssClasses () {
      return this.css && Array.isArray(this.css)
        ? [ ...this.css, this.variantClass, this.customClass ]
        : [ 'alert', this.variantClass, this.customClass ]
    },
    show () {
      return !this.closed && !!this.message
    }
  },
  methods: {
    closeFlash () {
      this.closed = true

      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      this.$emit('done')
    },
    autoClose () {
      this.timeout = setTimeout(() => {
        this.closeFlash()
      }, this.duration)
    }
  }
}
</script>
<style scoped>
  .message-notification {
    position: absolute;
    right: 50px;
    top: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/core/Message.vue